module.exports = __webpack_public_path__ + "img/succes-pin.0e20fb2f.svg";